import { parseCommentBody } from "@/features/collaboration/lib/mentions";

export type TextDirection = "rtl" | "ltr" | "auto";

const RIGHT_TO_LEFT_LETTER = /[\p{Script=Arabic}\p{Script=Hebrew}]/gu;
const LETTER = /\p{L}/gu;

/**
 * The direction most of the text is written in. Comments often start with a mention ("@سارة
 * the client prefers…"), so the first letter, which dir="auto" goes by, is a poor guide.
 * Without letters, or with as many of each, the browser decides ("auto").
 */
export function textDirection(text: string): TextDirection {
  const rightToLeft = text.match(RIGHT_TO_LEFT_LETTER)?.length ?? 0;
  const leftToRight = (text.match(LETTER)?.length ?? 0) - rightToLeft;
  if (rightToLeft === leftToRight) return "auto";
  return rightToLeft > leftToRight ? "rtl" : "ltr";
}

/** A comment's direction from its own words, leaving out the names it mentions. */
export function commentDirection(body: string): TextDirection {
  const words = parseCommentBody(body)
    .map((segment) => (segment.kind === "text" ? segment.text : ""))
    .join(" ");
  const direction = textDirection(words);
  return direction === "auto" ? textDirection(body) : direction;
}
